<template>
  <section class="transaction-detail">
    <NavigationBar />

    <!-- desktop -->
    <div
      v-if="!isVerySmall"
      class="uk-section uk-padding-remove-top uk-margin-top"
    >
      <div class="uk-container uk-margin-top">
        <div class="uk-flex" uk-grid>
          <NavigationProfile />
          <div class="uk-width-expand">
            <h3>Transaction Detail</h3>
            <hr />
            <div class="uk-flex" uk-grid v-if="!loading">
              <div class="uk-width-expand uk-flex uk-flex-left" uk-grid>
                <div
                  class="uk-width-1-1"
                  v-if="data.payment_status == 'Pending'"
                >
                  <h4 class="uk-heading-bullet uk-text-bold">
                    Payment Instructions
                  </h4>
                  <div
                    v-if="
                      [
                        'transfer',
                        'bca_va',
                        'mandiri_va',
                        'bni_va',
                        'bri_va',
                        'credit_card',
                      ].includes(data.payment_method)
                    "
                  >
                    <div>
                      Make a payment via
                      {{
                        data.payment_method == "transfer"
                          ? "ATM / transfer"
                          : data.payment_method == "credit_card"
                          ? "Visa / Master Card"
                          : ""
                      }}
                      with the following details:
                    </div>
                    <div class="uk-card uk-card-default uk-card-body">
                      <div class="uk-flex" uk-grid>
                        <div class="uk-width-auto uk-flex uk-flex-left">
                          <div>
                            <div class="uk-text-muted">Total</div>
                            <div class="uk-text-bold">
                              {{
                                data.payment_method == "transfer"
                                  ? priceRupiah(
                                      Number(data.total) +
                                        Number(data.unique_code)
                                    )
                                  : priceRupiah(data.total)
                              }}
                            </div>
                          </div>
                        </div>
                        <div
                          class="uk-width-expand uk-flex uk-flex-left"
                          v-if="data.payment_method == 'transfer'"
                        >
                          <div class="uk-alert-warning uk-width-1-1" uk-alert>
                            <p>Transfer exactly to the last 3 digits</p>
                          </div>
                        </div>
                      </div>
                      <hr />
                      <div
                        class="uk-flex"
                        uk-grid
                        v-if="
                          data.payment_method == 'transfer' &&
                          payment.code == 'BCA'
                        "
                      >
                        <div class="uk-width-auto uk-flex uk-flex-left">
                          <div>
                            <div class="uk-text-muted">Transfer News</div>
                            <div class="uk-text-bold">
                              {{ data.transfer_code }}
                            </div>
                          </div>
                        </div>
                        <div
                          class="uk-width-expand uk-flex uk-flex-left"
                          v-if="data.payment_method == 'transfer'"
                        >
                          <div class="uk-alert-warning uk-width-1-1" uk-alert>
                            <p>
                              Purchase cannot be processed!. If not accompanied
                              by a Transfer News.
                            </p>
                          </div>
                        </div>
                      </div>
                      <hr
                        v-if="
                          data.payment_method == 'transfer' &&
                          payment.code == 'BCA'
                        "
                      />
                      <div
                        class="uk-flex"
                        uk-grid
                        v-if="data.payment_method == 'transfer'"
                      >
                        <div class="uk-width-expand uk-flex uk-flex-left">
                          <div class="uk-width-1-1">
                            <span class="uk-text-muted"
                              >Destination Account</span
                            >
                            <div class="uk-width-1-1 uk-flex uk-flex-center">
                              <div class="destination-account-card">
                                <div class="uk-flex uk-flex-center">
                                  <img
                                    :src="$store.state.url + payment.image"
                                  />
                                </div>
                                <div
                                  class="uk-text-bold uk-flex uk-flex-center"
                                >
                                  <div>{{ payment.account_number }}</div>
                                </div>
                                <div class="uk-flex uk-flex-center">
                                  <div>{{ payment.account_name }}</div>
                                </div>
                                <div class="uk-flex uk-flex-center">
                                  <div>
                                    {{ payment.name }} {{ payment.branch }}
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div
                              class="uk-width-1-1 uk-flex uk-flex-center uk-margin-top"
                            >
                              <div>
                                <button
                                  class="uk-button uk-button-primary uk-button-small"
                                  @click="openModalConfirm()"
                                >
                                  Payment Confirmation
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        class="uk-flex"
                        uk-grid
                        v-else-if="data.payment_method == 'credit_card'"
                      >
                        <div class="uk-width-expand uk-flex uk-flex-center">
                          <a
                            class="uk-button uk-button-primary uk-button-small"
                            :href="
                              $store.state.urlTmm +
                              `checkout/credit_card?id=${data.code}`
                            "
                          >
                            Pay Now
                          </a>
                        </div>
                      </div>
                      <div class="uk-flex" uk-grid v-else>
                        <div class="uk-width-auto uk-flex uk-flex-left">
                          <div>
                            <div class="uk-text-muted">
                              Account Number {{ payment.account_name }}
                            </div>
                            <div class="uk-text-bold">
                              {{ payment.account_number }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="uk-width-1-1">
                  <h4 class="uk-heading-bullet uk-text-bold">Purchase List</h4>
                  <div
                    class="uk-card uk-card-default uk-card-body uk-margin-bottom"
                    v-for="(invoice, i) in invoice"
                    :key="i"
                  >
                    <div class="uk-flex" uk-grid>
                      <div class="uk-width-1-2 uk-flex uk-flex-left">
                        <div>
                          <div class="uk-text-muted">No. Invoice</div>
                          <div>{{ invoice.code }}</div>
                        </div>
                      </div>
                      <div class="uk-width-1-2 uk-flex uk-flex-left">
                        <div>
                          <div class="uk-text-muted">Merchant</div>
                          <div>{{ invoice.merchant_name }}</div>
                        </div>
                      </div>
                    </div>
                    <hr />
                    <div>
                      <div
                        class="uk-flex"
                        uk-grid
                        v-for="(product, j) in invoice.product"
                        :key="j"
                      >
                        <div class="uk-width-auto uk-flex uk-flex-middle">
                          <router-link :to="`../../product/${product.product}`">
                            <img
                              :src="$store.state.url + product.image"
                              width="65"
                            />
                          </router-link>
                        </div>
                        <div
                          class="uk-width-1-2 uk-flex uk-flex-top uk-padding-remove-left"
                        >
                          <div>
                            <div><router-link :to="`../../product/${product.product}`">{{ product.name }}</router-link></div>
                            <div>{{ product.code }}</div>
                            <div>Qty: {{ product.quantity }}</div>
                            <div>Weight: {{ product.weight }}</div>
                          </div>
                        </div>
                        <div
                          class="uk-width-expand uk-flex uk-flex-top uk-flex-right"
                        >
                          <div>
                            {{
                              priceRupiah(product.subtotal.replace(/,/g, ""))
                            }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <hr />
                    <div class="uk-flex uk-flex-left">
                      <div>
                        <div class="uk-text-muted">Purchase Status</div>
                        <div>{{ invoice.order_status_name }}</div>
                      </div>
                    </div>
                    <hr />
                    <div
                      class="uk-flex uk-flex-left"
                      style="margin-bottom: 5px"
                    >
                      <div>
                        <div class="uk-text-muted">Delivery Service</div>
                        <div>
                          {{
                            invoice.shipping_courier == "pickup"
                              ? "Ambil Sendiri"
                              : invoice.shipping_courier == "kurir-express"
                              ? "TOKOMANAMANA EXPRESS"
                              : invoice.shipping_courier == "grab"
                              ? "GRAB EXPRESS"
                              : invoice.shipping_courier
                                  .replace(/-/g, " ")
                                  .toUpperCase()
                          }}
                        </div>
                      </div>
                    </div>
                    <hr v-if="invoice.shipping_courier == 'pickup' && ['10', '11'].includes(invoice.order_status)" class="uk-flex uk-flex-left" />
                    <div v-if="invoice.shipping_courier == 'pickup' && ['10', '11'].includes(invoice.order_status)" class="uk-flex uk-flex-left" style="margin-bottom: 5px">
                      <div>
                        <div class="uk-text-muted">Address Of Taking</div>
                        <div class="uk-text-bold">{{ invoice.merchant_name }}</div>
                        <div>{{ invoice.merchant_address }}</div>
                        <div>{{ invoice.merchant_district }} - {{ invoice.merchant_city }}</div>
                        <div>{{ invoice.merchant_province }} {{ invoice.merchant_postcode }}</div>
                        <div>{{ invoice.merchant_telephone }}</div>
                        <div><a :href="`https://www.google.com/maps/search/?api=1&query=${invoice.merchant_lat},${invoice.merchant_lng}`" target="_blank" rel="noopener noreferrer">View on Google Maps</a></div>
                      </div>
                    </div>
                    <hr v-if="['11', '6', '5'].includes(invoice.order_status)" />
                    <div class="uk-flex uk-flex-left" style="margin-bottom: 5px;" v-if="['11', '6', '5'].includes(invoice.order_status)">
                      <div class="uk-width-1-1 uk-flex uk-flex-center">
                        <div>
                          <button class="uk-button-primary uk-button uk-button-small" @click="openModalConfirmProduct(invoice.code)">confirm product receipt</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="uk-width-1-3 uk-flex uk-margin-small-top section-detail-payment"
                uk-grid
              >
                <div class="uk-width-1-1">
                  <div class="uk-flex uk-flex-start uk-width-1-1">
                    <div>
                      <div class="uk-text-muted">No Transaction</div>
                      <div>{{ data.code }}</div>
                    </div>
                  </div>
                  <hr />
                  <div class="uk-flex uk-flex-start uk-width-1-1">
                    <div>
                      <div class="uk-text-muted">Billing Status</div>
                      <div>
                        <span
                          :class="`${
                            data.payment_status == 'Pending'
                              ? 'pending-status'
                              : data.payment_status == 'Paid'
                              ? 'paid-status'
                              : data.payment_status == 'Confirmed'
                              ? 'confirmed-status'
                              : 'cancel-status'
                          } status-transaction`"
                          >{{ data.payment_status }}</span
                        >
                      </div>
                    </div>
                  </div>
                  <hr />
                  <div class="uk-flex uk-flex-start uk-width-1-1">
                    <div>
                      <div class="uk-text-muted">Payment Method</div>
                      <div>{{ data.payment_method_name }}</div>
                    </div>
                  </div>
                  <hr />
                  <div class="uk-flex uk-flex-start uk-width-1-1">
                    <div>
                      <div class="uk-text-muted">Payment Limit</div>
                      <div>{{ data.due_date }}</div>
                    </div>
                  </div>
                  <hr />
                  <div class="uk-flex uk-flex-start uk-width-1-1">
                    <div class="uk-width-1-1">
                      <div class="uk-text-muted">Payment Detail</div>
                      <div class="uk-width-1-1 uk-flex">
                        <div
                          class="uk-width-1-2@m uk-width-1-1@s uk-flex uk-flex-left"
                        >
                          Price
                        </div>
                        <div
                          class="uk-width-1-2@m uk-width-1-1@s uk-flex uk-flex-right"
                        >
                          {{ priceRupiah(data.subtotal) }}
                        </div>
                      </div>
                      <div class="uk-width-1-1 uk-flex">
                        <div
                          class="uk-width-1-2@m uk-width-1-1@s uk-flex uk-flex-left"
                        >
                          Shipping Cost
                        </div>
                        <div
                          class="uk-width-1-2@m uk-width-1-1@s uk-flex uk-flex-right"
                        >
                          {{ priceRupiah(data.shipping_cost) }}
                        </div>
                      </div>
                      <div
                        class="uk-width-1-1 uk-flex"
                        v-if="data.payment_method == 'transfer'"
                      >
                        <div
                          class="uk-width-1-2@m uk-width-1-1@s uk-flex uk-flex-left"
                        >
                          Unique Code
                        </div>
                        <div
                          class="uk-width-1-2@m uk-width-1-1@s uk-flex uk-flex-right"
                        >
                          {{ priceRupiah(data.unique_code) }}
                        </div>
                      </div>
                      <div class="uk-width-1-1 uk-flex uk-text-bold">
                        <div
                          class="uk-width-1-2@m uk-width-1-1@s uk-flex uk-flex-left"
                        >
                          Total
                        </div>
                        <div
                          class="uk-width-1-2@m uk-width-1-1@s uk-flex uk-flex-right"
                        >
                          {{
                            data.payment_method == "transfer"
                              ? priceRupiah(
                                  Number(data.total) + Number(data.unique_code)
                                )
                              : priceRupiah(data.total)
                          }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <hr />
                  <div class="uk-flex uk-flex-start uk-width-1-1">
                    <div class="uk-width-1-1">
                      <div class="uk-text-muted">Shipping Address</div>
                      <div class="uk-text-bold" style="margin-top: 5px">
                        {{ data.shipping_name }}
                      </div>
                      <div>{{ data.shipping_phone }}</div>
                      <div>
                        {{ data.shipping_address }},
                        {{ data.shipping_postcode }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="uk-flex uk-flex-center uk-flex-midle" v-else>
              <div uk-spinner></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- mobile -->
    <div v-else class="uk-section uk-padding-remove-top uk-margin-top">
      <div class="uk-container uk-margin-top">
        <div class="uk-width-expand">
          <h3>Transaction Detail</h3>
          <div class="uk-width-1-1 uk-flex uk-flex-left" v-if="!loading">
            <div class="uk-width-1-1">
              <div class="uk-flex section-detail-payment" uk-grid>
                <div class="uk-width-1-1">
                  <div class="uk-flex uk-flex-start uk-width-1-1">
                    <div>
                      <div class="uk-text-muted">No Transaction</div>
                      <div>{{ data.code }}</div>
                    </div>
                  </div>
                  <hr />
                  <div class="uk-flex uk-flex-start uk-width-1-1">
                    <div>
                      <div class="uk-text-muted">Billing Status</div>
                      <div>
                        <span
                          :class="`${
                            data.payment_status == 'Pending'
                              ? 'pending-status'
                              : data.payment_status == 'Paid'
                              ? 'paid-status'
                              : data.payment_status == 'Confirmed'
                              ? 'confirmed-status'
                              : 'cancel-status'
                          } status-transaction`"
                          >{{ data.payment_status }}</span
                        >
                      </div>
                    </div>
                  </div>
                  <hr />
                  <div class="uk-flex uk-flex-start uk-width-1-1">
                    <div>
                      <div class="uk-text-muted">Payment Method</div>
                      <div>{{ data.payment_method_name }}</div>
                    </div>
                  </div>
                  <hr />
                  <div class="uk-flex uk-flex-start uk-width-1-1">
                    <div>
                      <div class="uk-text-muted">Payment Limit</div>
                      <div>{{ data.due_date }}</div>
                    </div>
                  </div>
                  <hr />
                  <div class="uk-flex uk-flex-start uk-width-1-1">
                    <div class="uk-width-1-1">
                      <div class="uk-text-muted">Payment Detail</div>
                      <div class="uk-width-1-1 uk-flex">
                        <div
                          class="uk-width-1-2@m uk-width-1-1@s uk-flex uk-flex-left"
                        >
                          Price
                        </div>
                        <div
                          class="uk-width-1-2@m uk-width-1-1@s uk-flex uk-flex-right"
                        >
                          {{ priceRupiah(data.subtotal) }}
                        </div>
                      </div>
                      <div class="uk-width-1-1 uk-flex">
                        <div
                          class="uk-width-1-2@m uk-width-1-1@s uk-flex uk-flex-left"
                        >
                          Shipping Cost
                        </div>
                        <div
                          class="uk-width-1-2@m uk-width-1-1@s uk-flex uk-flex-right"
                        >
                          {{ priceRupiah(data.shipping_cost) }}
                        </div>
                      </div>
                      <div
                        class="uk-width-1-1 uk-flex"
                        v-if="data.payment_method == 'transfer'"
                      >
                        <div
                          class="uk-width-1-2@m uk-width-1-1@s uk-flex uk-flex-left"
                        >
                          Unique Code
                        </div>
                        <div
                          class="uk-width-1-2@m uk-width-1-1@s uk-flex uk-flex-right"
                        >
                          {{ priceRupiah(data.unique_code) }}
                        </div>
                      </div>
                      <div class="uk-width-1-1 uk-flex uk-text-bold">
                        <div
                          class="uk-width-1-2@m uk-width-1-1@s uk-flex uk-flex-left"
                        >
                          Total
                        </div>
                        <div
                          class="uk-width-1-2@m uk-width-1-1@s uk-flex uk-flex-right"
                        >
                          {{
                            data.payment_method == "transfer"
                              ? priceRupiah(
                                  Number(data.total) + Number(data.unique_code)
                                )
                              : priceRupiah(data.total)
                          }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <hr />
                  <div class="uk-flex uk-flex-start uk-width-1-1">
                    <div class="uk-width-1-1">
                      <div class="uk-text-muted">Shipping Address</div>
                      <div class="uk-text-bold" style="margin-top: 5px">
                        {{ data.shipping_name }}
                      </div>
                      <div>{{ data.shipping_phone }}</div>
                      <div>
                        {{ data.shipping_address }},
                        {{ data.shipping_postcode }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <hr />
              <div
                class="uk-width-1-1 uk-margin-top"
                v-if="data.payment_status == 'Pending'"
              >
                <h4 class="uk-heading-bullet uk-text-bold">
                  Payment Instructions
                </h4>
                <div
                  v-if="
                    [
                      'transfer',
                      'bca_va',
                      'mandiri_va',
                      'bni_va',
                      'bri_va',
                      'credit_card',
                    ].includes(data.payment_method)
                  "
                >
                  <div>
                    Make a payment via
                    {{
                      data.payment_method == "transfer"
                        ? "ATM / transfer"
                        : data.payment_method == "credit_card"
                        ? "Visa / Master Card"
                        : ""
                    }}
                    with the following details:
                  </div>
                  <div class="uk-card uk-card-default uk-card-body">
                    <div class="uk-flex" uk-grid>
                      <div class="uk-width-auto uk-flex uk-flex-left">
                        <div>
                          <div class="uk-text-muted">Total</div>
                          <div class="uk-text-bold">
                            {{
                              data.payment_method == "transfer"
                                ? priceRupiah(
                                    Number(data.total) +
                                      Number(data.unique_code)
                                  )
                                : priceRupiah(data.total)
                            }}
                          </div>
                        </div>
                      </div>
                      <div
                        class="uk-width-expand uk-flex uk-flex-left"
                        v-if="data.payment_method == 'transfer'"
                      >
                        <div class="uk-alert-warning uk-width-1-1" uk-alert>
                          <p>Transfer exactly to the last 3 digits</p>
                        </div>
                      </div>
                    </div>
                    <hr />
                    <div
                      class="uk-flex"
                      uk-grid
                      v-if="
                        data.payment_method == 'transfer' &&
                        payment.code == 'BCA'
                      "
                    >
                      <div class="uk-width-auto uk-flex uk-flex-left">
                        <div>
                          <div class="uk-text-muted">Transfer News</div>
                          <div class="uk-text-bold">
                            {{ data.transfer_code }}
                          </div>
                        </div>
                      </div>
                      <div
                        class="uk-width-expand uk-flex uk-flex-left"
                        v-if="data.payment_method == 'transfer'"
                      >
                        <div class="uk-alert-warning uk-width-1-1" uk-alert>
                          <p>
                            Purchase cannot be processed!. If not accompanied by
                            a Transfer News.
                          </p>
                        </div>
                      </div>
                    </div>
                    <hr
                      v-if="
                        data.payment_method == 'transfer' &&
                        payment.code == 'BCA'
                      "
                    />
                    <div
                      class="uk-flex"
                      uk-grid
                      v-if="data.payment_method == 'transfer'"
                    >
                      <div class="uk-width-expand uk-flex uk-flex-left">
                        <div class="uk-width-1-1">
                          <span class="uk-text-muted">Destination Account</span>
                          <div class="uk-width-1-1 uk-flex uk-flex-center">
                            <div class="destination-account-card">
                              <div class="uk-flex uk-flex-center">
                                <img :src="$store.state.url + payment.image" />
                              </div>
                              <div class="uk-text-bold uk-flex uk-flex-center">
                                <div>{{ payment.account_number }}</div>
                              </div>
                              <div class="uk-flex uk-flex-center">
                                <div>{{ payment.account_name }}</div>
                              </div>
                              <div class="uk-flex uk-flex-center">
                                <div>
                                  {{ payment.name }} {{ payment.branch }}
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            class="uk-width-1-1 uk-flex uk-flex-center uk-margin-top"
                          >
                            <div>
                              <button
                                class="uk-button uk-button-primary uk-button-small"
                                @click="openModalConfirm()"
                              >
                                Payment Confirmation
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      class="uk-flex"
                      uk-grid
                      v-else-if="data.payment_method == 'credit_card'"
                    >
                      <div class="uk-width-expand uk-flex uk-flex-center">
                        <a
                          class="uk-button uk-button-primary uk-button-small"
                          :href="
                            $store.state.urlTmm +
                            `checkout/credit_card?id=${data.code}`
                          "
                        >
                          Pay Now
                        </a>
                      </div>
                    </div>
                    <div class="uk-flex" uk-grid v-else>
                      <div class="uk-width-auto uk-flex uk-flex-left">
                        <div>
                          <div class="uk-text-muted">
                            Account Number {{ payment.account_name }}
                          </div>
                          <div class="uk-text-bold">
                            {{ payment.account_number }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="uk-width-1-1 uk-margin-top">
                <h4 class="uk-heading-bullet uk-text-bold">Purchase List</h4>
                <div
                  class="uk-card uk-card-default uk-card-body uk-margin-bottom"
                  v-for="(invoice, i) in invoice"
                  :key="i"
                >
                  <div class="uk-flex" uk-grid>
                    <div class="uk-width-1-2 uk-flex uk-flex-left">
                      <div>
                        <div class="uk-text-muted">No. Invoice</div>
                        <div>{{ invoice.code }}</div>
                      </div>
                    </div>
                    <div class="uk-width-1-2 uk-flex uk-flex-left">
                      <div>
                        <div class="uk-text-muted">Merchant</div>
                        <div>{{ invoice.merchant_name }}</div>
                      </div>
                    </div>
                  </div>
                  <hr />
                  <div>
                    <div
                      class="uk-flex"
                      uk-grid
                      v-for="(product, j) in invoice.product"
                      :key="j"
                    >
                      <div class="uk-width-auto uk-flex uk-flex-middle">
                        <router-link :to="`../../product/${product.product}`">
                          <img
                            :src="$store.state.url + product.image"
                            width="65"
                          />
                        </router-link>
                      </div>
                      <div
                        class="uk-width-1-2 uk-flex uk-flex-top uk-padding-remove-left"
                      >
                        <div>
                          <div><router-link :to="`../../product/${product.product}`">{{ product.name }}</router-link></div>
                          <div>{{ product.code }}</div>
                          <div>Qty: {{ product.quantity }}</div>
                          <div>Weight: {{ product.weight }}</div>
                        </div>
                      </div>
                      <div
                        class="uk-width-expand uk-flex uk-flex-top uk-flex-right uk-padding-remove-left"
                      >
                        <div>
                          {{ priceRupiah(product.subtotal.replace(/,/g, "")) }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <hr />
                  <div class="uk-flex uk-flex-left">
                    <div>
                      <div class="uk-text-muted">Purchase Status</div>
                      <div>{{ invoice.order_status_name }}</div>
                    </div>
                  </div>
                  <hr />
                  <div class="uk-flex uk-flex-left" style="margin-bottom: 5px">
                    <div>
                      <div class="uk-text-muted">Delivery Service</div>
                      <div>
                        {{
                          invoice.shipping_courier == "pickup"
                            ? "Ambil Sendiri"
                            : invoice.shipping_courier == "kurir-express"
                            ? "TOKOMANAMANA EXPRESS"
                            : invoice.shipping_courier == "grab"
                            ? "GRAB EXPRESS"
                            : invoice.shipping_courier
                                .replace(/-/g, " ")
                                .toUpperCase()
                        }}
                      </div>
                    </div>
                  </div>
                  <hr v-if="invoice.shipping_courier == 'pickup' && ['10', '11'].includes(invoice.order_status)" />
                  <div v-if="invoice.shipping_courier == 'pickup' && ['10', '11'].includes(invoice.order_status)" class="uk-flex uk-flex-left" style="margin-bottom: 5px;">
                    <div>
                      <div class="uk-text-muted">Address Of Taking</div>
                      <div class="uk-text-bold">{{ invoice.merchant_name }}</div>
                      <div>{{ invoice.merchant_address }}</div>
                      <div>{{ invoice.merchant_district }} - {{ invoice.merchant_city }}</div>
                      <div>{{ invoice.merchant_province }} {{ invoice.merchant_postcode }}</div>
                      <div>{{ invoice.merchant_telephone }}</div>
                      <div><a :href="`https://www.google.com/maps/search/?api=1&query=${invoice.merchant_lat},${invoice.merchant_lng}`" target="_blank" rel="noopener noreferrer">View on Google Maps</a></div>
                    </div>
                  </div>
                  <hr v-if="['11', '6', '5'].includes(invoice.order_status)" />
                  <div class="uk-flex uk-flex-left" style="margin-bottom: 5px;" v-if="['11', '6', '5'].includes(invoice.order_status)">
                    <div class="uk-width-1-1 uk-flex uk-flex-center">
                      <div>
                        <button class="uk-button-primary uk-button uk-button-small" @click="openModalConfirmProduct(invoice.code)">confirm product receipt</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="uk-flex uk-flex-center uk-flex-midle" v-else>
            <div uk-spinner></div>
          </div>
        </div>
      </div>
    </div>

    <div id="modal-confirm-payment" class="uk-flex-top" uk-modal v-if="!loading">
      <div
        class="uk-modal-dialog uk-modal-body uk-margin-auto-vertical"
        style="width: 450px"
        v-if="data.payment_status == 'Pending' && data.payment_method == 'transfer'"
      >
        <button class="uk-modal-close-default" type="button" uk-close></button>

        <div class="uk-modal-header">
          <div class="uk-modal-title">Payment Confirmation</div>
        </div>
        <form @submit.prevent="confirmPayment()">
          <div class="uk-modal-body">
            <div class="uk-margin">
              <div>
                <div>Proof of Transaction</div>
                <input
                  type="file"
                  accept="image/*"
                  @change="handleFileUpload"
                />
              </div>
            </div>
            <!-- <div class="uk-margin">
              <input
                type="text"
                class="uk-input"
                v-model="confirmPaymentData.bank_pengirim"
                placeholder="Bank Pengirim"
              />
            </div> -->
            <div class="uk-margin">
              <textarea
                name="note"
                id="note"
                cols="30"
                rows="10"
                class="uk-textarea"
                placeholder="Notes"
                v-model="confirmPaymentData.note"
              ></textarea>
            </div>
          </div>
          <div class="uk-modal-footer uk-text-right">
            <button
              class="uk-button uk-button-default uk-modal-close uk-button-small uk-margin-small-right"
              type="button"
            >
              Cancel
            </button>
            <button
              class="uk-button uk-button-primary uk-button-small"
              type="submit"
            >
              Submit
            </button>
          </div>
        </form>
      </div>
    </div>

    <div id="modal-confirm-product" class="uk-flex-top" uk-modal v-if="!loading">
      <div
        class="uk-modal-dialog uk-modal-body uk-margin-auto-vertical"
        style="padding: 0px;"
      >
        <button class="uk-modal-close-default" type="button" uk-close></button>
        <form @submit.prevent="receiptConfirmation()">
          <div class="uk-modal-header">
            <div class="uk-modal-title">Are you sure the transaction <b>{{ this.codeConfirmProduct }}</b> has been received?</div>
          </div>
          <div class="uk-modal-body">
            <p>Do this confirmation only if your order has been received properly and completely. Because the transaction will be completed and your funds will be forwarded to the Seller.</p>
          </div>
          <div class="uk-modal-footer uk-text-right">
            <button
              class="uk-button uk-button-default uk-modal-close uk-button-small uk-margin-small-right"
              type="button"
            >
              No
            </button>
            <button
              class="uk-button uk-button-primary uk-button-small"
              type="submit"
            >
              Yes
            </button>
          </div>
        </form>
      </div>
    </div>
    <Footer />
  </section>
</template>

<script>
import NavigationBar from "@/components/NavigationBar.vue";
import Footer from "@/components/Footer.vue";
import NavigationProfile from "@/components/NavigationProfile.vue";
import { mapGetters } from "vuex";
import $axios from "../../api";
import UIkit from "uikit";

export default {
  components: {
    NavigationBar,
    NavigationProfile,
    Footer,
  },
  data() {
    return {
      data: null,
      loading: true,
      payment: null,
      invoice: [],
      confirmPaymentData: {
        note: "",
        file: "",
        bank_pengirim: "",
      },
      codeConfirmProduct: '',
    };
  },
  computed: {
    ...mapGetters("auth", ["IS_AUTH", "GET_USER"]),
    isSmall() {
      return window.innerWidth < 960;
    },
    isVerySmall() {
      return window.innerWidth < 640;
    },
  },
  mounted() {
    if (!this.$route.query.id) {
      this.$router.push("/not-found");
    } else {
      if (!this.IS_AUTH) {
        this.$router.push(`/?login=true&back=${window.location.origin + this.$route.path}?id=${this.$route.query.id}`);
      } else {
        this.getData();
      }
    }
  },
  methods: {
    openModalConfirmProduct(code) {
      this.codeConfirmProduct = code
      const element = document.querySelector('#modal-confirm-product')
      UIkit.modal(element).show()
    },
    receiptConfirmation(){
      $axios.post('customer/riwayat_pesanan/receipt_confirmation', {
        id_invoice: this.codeConfirmProduct,
        id_cust: this.GET_USER.id,
      }).then((res) => {
        if (res.status == 200) {
          const data = res.data
          if (data.success == 1) {
            const element = document.querySelector('#modal-confirm-product')
            UIkit.modal(element).hide()
            UIkit.notification({
              status: "success",
              message: "Success"
            })
            this.loading = true
            this.data = null
            this.getData()
          } else {
            UIkit.notification({
              status: 'danger',
              message: data.msg
            })
          }
        } else {
          console.warn(`Response Status ${res.status}`)
          UIkit.notification({
            status: 'danger',
            message: "Something went wrong!",
          })
        }
      }).catch((err) => {
        console.warn(err)
        UIkit.notification({
          status: 'danger',
          message: "Something went wrong!",
        })
      });
    },
    handleFileUpload(e) {
      // this.confirmPaymentData.file = this.$refs.fileUpload.files[0]
      if (e.target.files[0]) {
        if (e.target.files[0].size >= 10000000) {
          UIkit.notification({
            status: "danger",
            message: "File too large!",
          });
          e.target.value = null;
        } else {
          this.base64Image(e.target.files[0]);
        }
      }
    },
    base64Image(fileObject) {
      const reader = new FileReader();
      reader.onload = (e) => {
        this.confirmPaymentData.file = e.target.result;
      };
      reader.readAsDataURL(fileObject);
    },
    confirmPayment() {
      const modalElement = document.querySelector("#modal-confirm-payment");
      if (this.confirmPaymentData.file) {
        $axios
          .post("customer/riwayat_pesanan/confirm_payment", {
            order: this.data.code,
            id_cust: this.GET_USER.id,
            // bank_pengirim: this.confirmPaymentData.bank_pengirim,
            bank_pengirim: '',
            bukti: this.confirmPaymentData.file,
            catatan: this.confirmPaymentData.note,
            to: this.payment.to,
          })
          .then((res) => {
            if (res.status == 200) {
              const data = res.data;
              if (data.success == 1) {
                UIkit.modal(modalElement).hide()
                UIkit.notification({
                  status: "success",
                  message: "Success"
                })
                this.loading = true
                this.data = null
                this.getData()
              } else {
                console.log(data);
                UIkit.notification({
                  status: "danger",
                  message: data.msg,
                });
              }
            } else {
              console.log(res.status);
              UIkit.notification({
                status: "danger",
                message: "Something went wrong!",
              });
            }
          })
          .catch((err) => {
            console.log(err);
            UIkit.notification({
              status: "danger",
              message: "Something went wrong!",
            });
          });
      } else {
        UIkit.notification({
          status: 'danger',
          message: 'Proof of Transaction must be filled!'
        })
      }
    },
    getData() {
      $axios
        .post("customer/riwayat_pesanan/detail", {
          id_cust: this.GET_USER.id,
          id_order: this.$route.query.id,
        })
        .then((res) => {
          if (res.status == 200) {
            const data = res.data;
            if (data.success == 1) {
              this.data = data.data;
              if (data.data.payment_method == "transfer" && data.data.payment_status == 'Pending') {
                for (const payment in data.payment) {
                  if (Object.hasOwnProperty.call(data.payment, payment)) {
                    const element = data.payment[payment];
                    this.payment = element;
                    this.payment.to = payment
                  }
                }
              } else {
                this.payment = data.payment;
              }
              this.invoice = data.inv;
              this.loading = false;
              this.setSeo();
            } else {
              this.$router.push("/not-found");
            }
          } else {
            this.$router.push("/not-found");
          }
        })
        .catch((err) => {
          console.warn(err);
          // this.$router.push("/not-found");
        });
    },
    priceRupiah: function (number) {
      let reverse = number.toString().split("").reverse().join("");
      let ribuan = reverse.match(/\d{1,3}/g);
      ribuan = ribuan.join(".").split("").reverse().join("");
      return "Rp " + ribuan;
    },
    openModalConfirm() {
      const modalElement = document.querySelector("#modal-confirm-payment");
      UIkit.modal(modalElement).show();
    },
    setSeo() {
      let titlePage = `Order:: ${this.data.code}`;
      const siteDescription = `Order:: ${this.data.code}`;
      document.title = titlePage;
      const check_meta = document.querySelectorAll("meta");
      let count_check = 0;
      check_meta.forEach((check) => {
        if (
          check.getAttribute("name") == "description" ||
          check.getAttribute("name") == "title" ||
          check.getAttribute("name") == "robots"
        ) {
          if (check.getAttribute("name") == "description") {
            check.setAttribute("content", "");
          }
          if (check.getAttribute("name") == "title") {
            check.setAttribute("content", titlePage);
          }
          if (check.getAttribute("name") == "robots") {
            check.setAttribute("content", "index, follow");
          }
          count_check = 1;
        }
      });
      if (count_check == 0) {
        var meta_description = document.createElement("meta");
        meta_description.setAttribute("name", "description");
        meta_description.setAttribute("content", siteDescription);
        document.getElementsByTagName("head")[0].appendChild(meta_description);
        const meta_title = document.createElement("meta");
        meta_title.setAttribute("name", "title");
        meta_title.setAttribute("content", titlePage);
        document.getElementsByTagName("head")[0].appendChild(meta_title);
        const meta_robots = document.createElement("meta");
        meta_robots.setAttribute("name", "robots");
        meta_robots.setAttribute("content", "index, follow");
        document.getElementsByTagName("head")[0].appendChild(meta_robots);
      }
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../custom/custom.less";
.transaction-detail {
  font-size: 14px;

  .section-detail-payment {
    hr {
      margin-top: 10px;
      margin-bottom: 10px;
    }
  }

  .uk-card-body {
    padding: 20px;
  }

  .destination-account-card {
    background: white;
    border: 1px solid #e1e1e1;
    padding: 10px 30px;
  }

  .status-transaction {
    font-size: 9px !important;
    color: white;
    padding: 5px;
    border-radius: 4px;
  }
  .pending-status {
    background: @warning-color;
  }
  .paid-status {
    background: @success-color;
  }
  .confirmed-status {
    background: @info-color;
  }
  .cancel-status {
    background: @danger-color;
  }
}
</style>